export const OLD_URLS_MAP: Record<string, string> = {
    '/category/horrors': '/category/horror',
    '/category/2_player': '/category/two-player',
    '/category/simulator': '/category/simulation',
    '/category/match3': '/category/match-3',
    '/category/tests': '/category/quiz',
    '/category/quize': '/category/quiz',
    '/category/economic': '/category/idle',
    '/category/role': '/category/rpg',
    '/category/applications': '/category/app-store',
    '/category/casino': '/category/cards',
    '/category/casual': '/category/easy',
    '/category/balloons': '/category/bubble-shooter',
    '/category/race': '/category/racing',
    '/category/tabletop': '/category/board',
    '/category/humor': '/category/funny',
    '/category/midcore': '/category/strategy',
    '/tag/two-player-games-games': '/category/two-player',
    '/tag/two-player-games': '/category/two-player',
    '/tag/2-player-games': '/category/two-player',
    '/tag/2-player': '/category/two-player',
    '/tag/two-players': '/category/two-player',
    '/category/2-player-games': '/category/two-player',
    // tags to new tags
    '/tag/games-3d': '/category/3d',
    '/tag/games-1-player': '/tag/1-player-games',
    '/tag/school': '/tag/school-games',
    '/tag/grooming': '/tag/grooming-games',
    '/tag/hairdressing': '/tag/hairdressing-games',
    '/tag/2d': '/tag/2d-games',
    '/tag/game': '/',
    '/tag/farming': '/tag/farming-games',
    '/tag/ship': '/tag/ship-games',
    '/tag/hot': '/tag/hot-games',
    '/tag/phazer': '/tag/phazer-games',
    '/tag/japanese': '/tag/japanese-games',
    '/tag/fox': '/tag/fox-games',
    '/tag/battle': '/tag/battle-games',
    '/tag/stunt': '/tag/stunt-games',
    '/tag/reaction': '/tag/reaction-games',
    '/tag/3-player': '/tag/3-player-games',
    '/tag/mission': '/tag/mission-games',
    '/tag/side-scrolling': '/tag/side-scrolling-games',
    '/tag/ships': '/tag/ships-games',
    '/tag/sharks': '/tag/sharks-games',
    '/tag/collect': '/tag/collect-games',
    '/tag/cleaning': '/tag/cleaning-games',
    '/tag/survivors': '/tag/survivors-games',
    '/tag/hero': '/tag/hero-games',
    '/tag/bullet': '/tag/bullet-games',
    '/tag/fast-paced': '/tag/fast-paced-games',
    '/tag/bottle-flip': '/tag/bottle-flip-games',
    '/tag/fantasy': '/tag/fantasy-games',
    '/tag/willie': '/tag/willie-games',
    '/tag/customization': '/tag/customization-games',
    '/tag/offroad': '/tag/offroad-games',
    '/tag/fruits': '/tag/fruits-games',
    '/tag/temple': '/tag/temple-games',
    '/tag/badminton': '/tag/badminton-games',
    '/tag/creative': '/tag/creative-games',
    '/tag/designer': '/tag/designer-games',
    '/tag/jigsaw': '/tag/jigsaw-games',
    '/tag/fortnite-ripoff': '/tag/fortnite-ripoff-games',
    '/tag/meme': '/tag/meme-games',
    '/tag/business': '/tag/business-games',
    '/tag/scratch': '/tag/scratch-games',
    '/tag/balls': '/tag/balls-games',
    '/tag/ethical': '/tag/ethical-games',
    '/tag/voxel': '/tag/voxel-games',
    '/tag/fullscreen': '/tag/fullscreen-games',
    '/tag/destruction': '/tag/destruction-games',
    '/tag/multiple-players': '/tag/multiple-players-games',
    '/tag/babysitting': '/tag/babysitting-games',
    '/tag/chat': '/tag/chat-games',
    '/tag/sim': '/tag/sim-games',
    '/tag/hardcore': '/tag/hardcore-games',
    '/tag/jewel': '/tag/jewel-games',
    '/tag/knife': '/tag/knife-games',
    '/tag/quests': '/tag/quests-games',
    '/tag/armor': '/tag/armor-games',
    '/tag/widget': '/tag/widget-games',
    '/tag/shapes': '/tag/shapes-games',
    '/tag/3rd-person-shooter': '/tag/3rd-person-shooter-games',
    '/tag/mystery': '/tag/mystery-games',
    '/tag/relaxing': '/tag/relaxing-games',
    '/tag/attention': '/tag/attention-games',
    '/tag/brain-training': '/tag/brain-training-games',
    '/tag/dark': '/tag/dark-games',
    '/tag/dodge': '/tag/dodge-games',
    '/tag/choice': '/tag/choice-games',
    '/tag/interactive': '/tag/interactive-games',
    '/tag/skills': '/tag/skills-games',
    '/tag/obstacle': '/tag/obstacle-games',
    '/tag/ice': '/tag/ice-games',
    '/tag/destroy': '/tag/destroy-games',
    '/tag/games-3-player': '/tag/3-player-games',
    '/tag/air': '/tag/air-games',
    '/tag/top-down': '/tag/top-down-games',
    '/tag/helix': '/tag/helix-games',
    '/tag/water': '/tag/water-games',
    '/tag/delivery': '/tag/delivery-games',
    '/tag/hyper-casual': '/tag/hyper-casual-games',
    '/tag/adult': '/tag/adult-games',
    '/tag/house': '/tag/house-games',
    '/tag/addictive': '/tag/addictive-games',
    '/tag/exciting': '/tag/exciting-games',
    '/tag/bakery': '/tag/bakery-games',
    '/tag/blow-up': '/tag/blow-up-games',
    '/tag/noob': '/tag/noob-games',
    '/tag/pregnancy': '/tag/pregnancy-games',
    '/tag/fighter-jet': '/tag/fighter-jet-games',
    '/tag/goalkeeper': '/tag/goalkeeper-games',
    '/tag/rabbit': '/tag/rabbit-games',
    '/tag/red': '/tag/red-games',
    '/tag/sky': '/tag/sky-games',
    '/tag/wtf': '/tag/wtf-games',
    '/tag/dash': '/tag/dash-games',
    '/tag/avoid': '/tag/avoid-games',
    '/tag/visual-novel': '/tag/visual-novel-games',
    '/tag/unity3d': '/tag/unity3d-games',
    '/tag/vehicles': '/tag/vehicles-games',
    '/tag/roblox': '/tag/roblox-games',
    '/tag/memory': '/tag/memory-games',
    '/tag/characters': '/tag/characters-games',
    '/tag/medieval': '/tag/medieval-games',
    '/tag/ambulance': '/tag/ambulance-games',
    '/tag/mom': '/tag/mom-games',
    '/tag/pet': '/tag/pet-games',
    '/tag/blocky': '/tag/blocky-games',
    '/tag/surfers': '/tag/surfers-games',
    '/tag/planet': '/tag/planet-games',
    '/tag/professional': '/tag/professional-games',
    '/tag/life-simulation': '/tag/life-simulation-games',
    '/tag/stars': '/tag/stars-games',
    '/tag/colorful': '/tag/colorful-games',
    '/tag/trial': '/tag/trial-games',
    '/tag/tournament': '/tag/tournament-games',
    '/tag/snowboarding': '/tag/snowboarding-games',
    '/tag/brick': '/tag/brick-games',
    '/tag/hypercasual': '/tag/hypercasual-games',
    '/tag/crash': '/tag/crash-games',
    '/tag/stealth': '/tag/stealth-games',
    '/tag/hopy': '/tag/hopy-games',
    '/tag/smash': '/tag/smash-games',
    '/tag/beauty-salon': '/tag/beauty-salon-games',
    '/tag/mentolatux': '/tag/mentolatux-games',
    '/tag/shooter': '/tag/shooter-games',
    '/tag/endless': '/tag/endless-games',
    '/tag/mafia': '/tag/mafia-games',
    '/tag/wedding': '/tag/wedding-games',
    '/tag/detective': '/tag/detective-games',
    '/tag/slide': '/tag/slide-games',
    '/tag/jelly': '/tag/jelly-games',
    '/tag/creativity': '/tag/creativity-games',
    '/tag/obstacles': '/tag/obstacles-games',
    '/tag/flip': '/tag/flip-games',
    '/tag/fairy-tale': '/tag/fairy-tale-games',
    '/tag/vex': '/tag/vex-games',
    '/tag/fairies': '/tag/fairies-games',
    '/tag/painting': '/tag/painting-games',
    '/tag/sofia': '/tag/sofia-games',
    '/tag/highscore': '/tag/highscore-games',
    '/tag/yoga': '/tag/yoga-games',
    '/tag/neon': '/tag/neon-games',
    '/tag/lines': '/tag/lines-games',
    '/tag/darts': '/tag/darts-games',
    '/tag/backflip': '/tag/backflip-games',
    '/tag/challenging': '/tag/challenging-games',
    '/tag/rts': '/tag/rts-games',
    '/tag/connect': '/tag/connect-games',
    '/tag/chair': '/tag/chair-games',
    '/tag/sorting': '/tag/sorting-games',
    '/tag/cute': '/tag/cute-games',
    '/tag/guns': '/tag/guns-games',
    '/tag/pyramid-solitaire': '/tag/pyramid-solitaire-games',
    '/tag/trollface': '/tag/trollface-games',
    '/tag/goal': '/tag/goal-games',
    '/tag/brain-out': '/tag/brain-out-games',
    '/tag/skiing': '/tag/skiing-games',
    '/tag/skateboard': '/tag/skateboard-games',
    '/tag/valentine-day': '/tag/valentine-day-games',
    '/tag/room': '/tag/room-games',
    '/tag/jumping': '/tag/jumping-games',
    '/tag/crossword-puzzles': '/tag/crossword-puzzles-games',
    '/tag/sliding': '/tag/sliding-games',
    '/tag/heroes': '/tag/heroes-games',
    '/tag/art': '/tag/art-games',
    '/tag/breaking': '/tag/breaking-games',
    '/tag/high-score': '/tag/high-score-games',
    '/tag/tnt': '/tag/tnt-games',
    '/tag/lol': '/tag/lol-games',
    '/tag/rocket': '/tag/rocket-games',
    '/tag/fly': '/tag/fly-games',
    '/tag/controller': '/tag/controller-games',
    '/tag/volleyball': '/tag/volleyball-games',
    '/tag/speed': '/tag/speed-games',
    '/tag/bricks': '/tag/bricks-games',
    '/tag/arena': '/tag/arena-games',
    '/tag/learning': '/tag/learning-games',
    '/tag/roller-coaster': '/tag/roller-coaster-games',
    '/tag/disney': '/tag/disney-games',
    '/tag/spot-the-difference': '/tag/spot-the-difference-games',
    '/tag/one-button': '/tag/one-button-games',
    '/tag/car-tuning': '/tag/car-tuning-games',
    '/tag/seek-and-find': '/tag/seek-and-find-games',
    '/tag/swing': '/tag/swing-games',
    '/tag/webgl': '/tag/webgl-games',
    '/tag/fish-aquarium': '/tag/fish-aquarium-games',
    '/tag/mind': '/tag/mind-games',
    '/tag/chicken': '/tag/chicken-games',
    '/tag/text': '/tag/text-games',
    '/tag/test': '/tag/test-games',
    '/tag/motocross': '/tag/motocross-games',
    '/tag/car-crash': '/tag/car-crash-games',
    '/tag/nails': '/tag/nails-games',
    '/tag/shop': '/tag/shop-games',
    '/tag/witch': '/tag/witch-games',
    '/tag/avie': '/tag/avie-games',
    '/tag/reward': '/tag/reward-games',
    '/tag/drift': '/tag/drift-games',
    '/tag/defense': '/tag/defense-games',
    '/tag/cut': '/tag/cut-games',
    '/tag/audio': '/tag/audio-games',
    '/tag/hide-and-seek': '/tag/hide-and-seek-games',
    '/tag/doll': '/tag/doll-games',
    '/tag/visual': '/tag/visual-games',
    '/tag/combat': '/tag/combat-games',
    '/tag/sword': '/tag/sword-games',
    '/tag/craft': '/tag/craft-games',
    '/tag/rescue': '/tag/rescue-games',
    '/tag/turn-based': '/tag/turn-based-games',
    '/tag/robbery': '/tag/robbery-games',
    '/tag/amazing': '/tag/amazing-games',
    '/tag/luck': '/tag/luck-games',
    '/tag/hidden-objects': '/tag/hidden-objects-games',
    '/tag/color-matching': '/tag/color-matching-games',
    '/tag/digging': '/tag/digging-games',
    '/tag/touchscreen': '/tag/touchscreen-games',
    '/tag/drag-racing': '/tag/drag-racing-games',
    '/tag/logical': '/tag/logical-games',
    '/tag/surprise': '/tag/surprise-games',
    '/tag/world': '/tag/world-games',
    '/tag/road': '/tag/road-games',
    '/tag/hip-hop': '/tag/hip-hop-games',
    '/tag/collecting': '/tag/collecting-games',
    '/tag/challenge': '/tag/challenge-games',
    '/tag/trap': '/tag/trap-games',
    '/tag/unicorns': '/tag/unicorns-games',
    '/tag/cult': '/tag/cult-games',
    '/tag/cartoon': '/tag/cartoon-games',
    '/tag/super': '/tag/super-games',
    '/tag/agility': '/tag/agility-games',
    '/tag/gravity': '/tag/gravity-games',
    '/tag/arrows': '/tag/arrows-games',
    '/tag/true-or-false': '/tag/true-or-false-games',
    '/tag/pomni': '/tag/pomni-games',
    '/tag/nickelodeon': '/tag/nickelodeon-games',
    '/tag/numbers': '/tag/numbers-games',
    '/tag/desktop': '/tag/desktop-games',
    '/tag/gangster': '/tag/gangster-games',
    '/tag/rolling': '/tag/rolling-games',
    '/tag/isometric': '/tag/isometric-games',
    '/tag/person': '/tag/person-games',
    '/tag/panda': '/tag/panda-games',
    '/tag/kitty': '/tag/kitty-games',
    '/tag/poop': '/tag/poop-games',
    '/tag/1-player': '/tag/1-player-games',
    '/tag/koala': '/tag/koala-games',
    '/tag/box': '/tag/box-games',
    '/tag/swipe': '/tag/swipe-games',
    '/tag/circus': '/tag/circus-games',
    '/tag/timing': '/tag/timing-games',
    '/tag/kissing': '/tag/kissing-games',
    '/tag/ghosts': '/tag/ghosts-games',
    '/tag/helicopter': '/tag/helicopter-games',
    '/tag/search': '/tag/search-games',
    '/tag/family': '/tag/family-games',
    '/tag/dance': '/tag/dance-games',
    '/tag/egg': '/tag/egg-games',
    '/tag/bloody': '/tag/bloody-games',
    '/tag/surfing': '/tag/surfing-games',
    '/tag/balance': '/tag/balance-games',
    '/tag/tiles': '/tag/tiles-games',
    '/tag/baby': '/tag/baby-games',
    '/tag/builder': '/tag/builder-games',
    '/tag/grow': '/tag/grow-games',
    '/tag/indie': '/tag/indie-games',
    '/tag/mountain': '/tag/mountain-games',
    '/tag/knights': '/tag/knights-games',
    '/tag/shark': '/tag/shark-games',
    '/tag/demolition-cars': '/tag/demolition-cars-games',
    '/tag/celebrity': '/tag/celebrity-games',
    '/tag/interactive-fiction': '/tag/interactive-fiction-games',
    '/tag/traffic': '/tag/traffic-games',
    '/tag/aircraft': '/tag/aircraft-games',
    '/tag/sci-fi': '/tag/sci-fi-games',
    '/tag/dentistry': '/tag/dentistry-games',
    '/tag/vampires': '/tag/vampires-games',
    '/tag/pet-grooming': '/tag/pet-grooming-games',
    '/tag/movie': '/tag/movie-games',
    '/tag/silver': '/tag/silver-games',
    '/tag/robots': '/tag/robots-games',
    '/tag/seduction': '/tag/seduction-games',
    '/tag/frog': '/tag/frog-games',
    '/tag/collection': '/tag/collection-games',
    '/tag/sandbox': '/tag/sandbox-games',
    '/tag/level': '/tag/level-games',
    '/tag/eating': '/tag/eating-games',
    '/tag/hearts': '/tag/hearts-games',
    '/tag/capture': '/tag/capture-games',
    '/tag/incremental': '/tag/incremental-games',
    '/tag/dogs': '/tag/dogs-games',
    '/tag/science': '/tag/science-games',
    '/tag/rally': '/tag/rally-games',
    '/tag/roguelike': '/tag/roguelike-games',
    '/tag/building': '/tag/building-games',
    '/tag/geometry': '/tag/geometry-games',
    '/tag/games': '/',
    '/tag/diamonds': '/tag/diamonds-games',
    '/tag/aviation': '/tag/aviation-games',
    '/tag/tactical': '/tag/tactical-games',
    '/tag/bow': '/tag/bow-games',
    '/tag/teams': '/tag/teams-games',
    '/tag/bike-racing': '/tag/bike-racing-games',
    '/tag/chekers': '/tag/chekers-games',
    '/tag/jump-scare': '/tag/jump-scare-games',
    '/tag/kart': '/tag/kart-games',
    '/tag/cash': '/tag/cash-games',
    '/tag/horde-survival': '/tag/horde-survival-games',
    '/tag/resource-management': '/tag/resource-management-games',
    '/tag/mice': '/tag/mice-games',
    '/tag/snow': '/tag/snow-games',
    '/tag/mmo': '/tag/mmo-games',
    '/tag/high-quality': '/tag/high-quality-games',
    '/tag/slicing': '/tag/slicing-games',
    '/tag/domino': '/tag/domino-games',
    '/tag/weird': '/tag/weird-games',
    '/tag/dungeon': '/tag/dungeon-games',
    '/tag/slitherio': '/tag/slitherio-games',
    '/tag/rival': '/tag/rival-games',
    '/tag/russian': '/tag/russian-games',
    '/tag/cartoon-network': '/tag/cartoon-network-games',
    '/tag/pegasus': '/tag/pegasus-games',
    '/tag/dunking': '/tag/dunking-games',
    '/tag/king': '/tag/king-games',
    '/tag/simple': '/tag/simple-games',
    '/tag/psychology': '/tag/psychology-games',
    '/tag/cartoons': '/tag/cartoons-games',
    '/tag/bird': '/tag/bird-games',
    '/tag/mermaid': '/tag/mermaid-games',
    '/tag/sneak': '/tag/sneak-games',
    '/tag/ping-pong': '/tag/ping-pong-games',
    '/tag/killing': '/tag/killing-games',
    '/tag/runner': '/tag/runner-games',
    '/tag/stacking': '/tag/stacking-games',
    '/tag/billiards': '/tag/billiards-games',
    '/tag/karting': '/tag/karting-games',
    '/tag/children': '/tag/children-games',
    '/tag/mining': '/tag/mining-games',
    '/tag/open-world': '/tag/open-world-games',
    '/tag/gold': '/tag/gold-games',
    '/tag/historical': '/tag/historical-games',
    '/tag/wheel': '/tag/wheel-games',
    '/tag/pixel': '/tag/pixel-games',
    '/tag/stairs': '/tag/stairs-games',
    '/tag/piano': '/tag/piano-games',
    '/tag/fire': '/tag/fire-games',
    '/tag/islands': '/tag/islands-games',
    '/tag/throwing': '/tag/throwing-games',
    '/tag/soldier': '/tag/soldier-games',
    '/tag/horses': '/tag/horses-games',
    '/tag/borwser': '/tag/borwser-games',
    '/tag/jungle': '/tag/jungle-games',
    '/tag/pinball': '/tag/pinball-games',
    '/tag/santa-claus': '/tag/santa-claus-games',
    '/tag/virtual': '/tag/virtual-games',
    '/tag/slacking': '/tag/slacking-games',
    '/tag/balloon': '/tag/balloon-games',
    '/tag/rhythm': '/tag/rhythm-games',
    '/tag/whack': '/tag/whack-games',
    '/tag/buggy': '/tag/buggy-games',
    '/tag/blackjack': '/category/cards',
    '/tag/moral': '/category/simulation',
    '/tag/monster-high': '/series/monster-high-games',
    '/tag/number-games': '/category/number',
    '/tag/mr-bean': '/series/mr-bean-games',
    '/tag/beat-em-up': '/category/fighting',
    '/tag/first-person': '/category/first-person-shooter',
    '/tag/supernatural': '/category/horror',
    '/tag/paranormal': '/category/horror',
    '/tag/spooky': '/category/horror',
    '/tag/spongebob': '/series/spongebob-games',
    '/tag/railroad': '/category/train',
    '/tag/physics-based': '/category/physics',
    '/tag/missles': '/category/battleship',
    '/tag/elevator': '/category/escape',
    '/tag/minimalist': '/category/mini',
    '/tag/word-games': '/category/words',
    '/tag/drag-and-aim': '/category/skill',
    '/tag/decision': '/tag/decision-games',
    '/tag/my-dolphin-show': '/series/my-dolphin-show-games',
    '/tag/battlefield': '/category/war',
    '/tag/trolley': '/series/trolley-games',
    '/tag/post-apocalypse': '/category/zombie',
    '/tag/sheriff-callie': '/category/police',
    '/tag/katana': '/category/ninja',
    '/tag/labyrinth': '/category/maze',
    '/tag/games-3d-games': '/category/3d',
    '/tag/gametok': '/',
    '/tag/modification': '/',
    '/tag/engaging': '/',
    '/tag/masyanya': '/',
    '/tag/no-registaration': '/',
    '/tag/topdown-games': '/',
    '/tag/real-time': '/',
    '/tag/lazy-town': '/',
    '/tag/0': '/',
    '/tag/gfkpa715': '/',
    '/tag/gfkpa441': '/',
    '/tag/charlotte': '/',
    '/tag/1234567890': '/',
    // category to new tag
    '/category/games-for-pc': '/tag/games-for-pc',
    '/category/city-building-games': '/tag/city-building-games',
    '/category/race-games': '/tag/race-games',
    '/category/minigames': '/tag/minigames',
    '/category/first-person-shooter-fps-games': '/tag/first-person-shooter-fps-games',
    '/category/games-for-teens': '/tag/games-for-teens',
    '/category/tanks-games': '/tag/tanks-games',
    '/category/games-3d': '/category/3d',
    '/category/games-1-player': '/tag/1-player-games',
    '/category/animals-games': '/tag/animals-games',
    '/category/games-for-pregnant-women': '/tag/games-for-pregnant-women',
    '/category/top-down-games': '/tag/top-down-games',
    '/category/school': '/tag/school-games',
    '/category/grooming': '/tag/grooming-games',
    '/category/hairdressing': '/tag/hairdressing-games',
    '/category/2d': '/tag/2d-games',
    '/category/game': '/tag/game-games',
    '/category/farming': '/tag/farming-games',
    '/category/ship': '/tag/ship-games',
    '/category/hot': '/tag/hot-games',
    '/category/phazer': '/tag/phazer-games',
    '/category/japanese': '/tag/japanese-games',
    '/category/fox': '/tag/fox-games',
    '/category/battle': '/tag/battle-games',
    '/category/stunt': '/tag/stunt-games',
    '/category/reaction': '/tag/reaction-games',
    '/category/3-player': '/tag/3-player-games',
    '/category/mission': '/tag/mission-games',
    '/category/side-scrolling': '/tag/side-scrolling-games',
    '/category/ships': '/tag/ships-games',
    '/category/sharks': '/tag/sharks-games',
    '/category/collect': '/tag/collect-games',
    '/category/cleaning': '/tag/cleaning-games',
    '/category/survivors': '/tag/survivors-games',
    '/category/hero': '/tag/hero-games',
    '/category/bullet': '/tag/bullet-games',
    '/category/fast-paced': '/tag/fast-paced-games',
    '/category/bottle-flip': '/tag/bottle-flip-games',
    '/category/fantasy': '/tag/fantasy-games',
    '/category/willie': '/tag/willie-games',
    '/category/customization': '/tag/customization-games',
    '/category/offroad': '/tag/offroad-games',
    '/category/fruits': '/tag/fruits-games',
    '/category/cats-games': '/tag/cats-games',
    '/category/temple': '/tag/temple-games',
    '/category/badminton': '/tag/badminton-games',
    '/category/creative': '/tag/creative-games',
    '/category/designer': '/tag/designer-games',
    '/category/jigsaw': '/tag/jigsaw-games',
    '/category/fortnite-ripoff': '/tag/fortnite-ripoff-games',
    '/category/meme': '/tag/meme-games',
    '/category/business': '/tag/business-games',
    '/category/scratch': '/tag/scratch-games',
    '/category/balls': '/tag/balls-games',
    '/category/ethical': '/tag/ethical-games',
    '/category/voxel': '/tag/voxel-games',
    '/category/fullscreen': '/tag/fullscreen-games',
    '/category/destruction': '/tag/destruction-games',
    '/category/multiple-players': '/tag/multiple-players-games',
    '/category/babysitting': '/tag/babysitting-games',
    '/category/chat': '/tag/chat-games',
    '/category/sim': '/tag/sim-games',
    '/category/hardcore': '/tag/hardcore-games',
    '/category/jewel': '/tag/jewel-games',
    '/category/knife': '/tag/knife-games',
    '/category/quests': '/tag/quests-games',
    '/category/armor': '/tag/armor-games',
    '/category/widget': '/tag/widget-games',
    '/category/shapes': '/tag/shapes-games',
    '/category/3rd-person-shooter': '/tag/3rd-person-shooter-games',
    '/category/mystery': '/tag/mystery-games',
    '/category/relaxing': '/tag/relaxing-games',
    '/category/attention': '/tag/attention-games',
    '/category/brain-training': '/tag/brain-training-games',
    '/category/dark': '/tag/dark-games',
    '/category/dodge': '/tag/dodge-games',
    '/category/choice': '/tag/choice-games',
    '/category/interactive': '/tag/interactive-games',
    '/category/skills': '/tag/skills-games',
    '/category/obstacle': '/tag/obstacle-games',
    '/category/ice': '/tag/ice-games',
    '/category/destroy': '/tag/destroy-games',
    '/category/games-3-player': '/tag/games-3-player-games',
    '/category/air': '/tag/air-games',
    '/category/top-down': '/tag/top-down-games',
    '/category/helix': '/tag/helix-games',
    '/category/water': '/tag/water-games',
    '/category/water-games': '/tag/water-games',
    '/category/delivery': '/tag/delivery-games',
    '/category/hyper-casual': '/tag/hyper-casual-games',
    '/category/adult': '/tag/adult-games',
    '/category/house': '/tag/house-games',
    '/category/addictive': '/tag/addictive-games',
    '/category/exciting': '/tag/exciting-games',
    '/category/bakery': '/tag/bakery-games',
    '/category/blow-up': '/tag/blow-up-games',
    '/category/noob': '/tag/noob-games',
    '/category/pregnancy': '/tag/pregnancy-games',
    '/category/fighter-jet': '/tag/fighter-jet-games',
    '/category/goalkeeper': '/tag/goalkeeper-games',
    '/category/rabbit': '/tag/rabbit-games',
    '/category/red': '/tag/red-games',
    '/category/sky': '/tag/sky-games',
    '/category/wtf': '/tag/wtf-games',
    '/category/dash': '/tag/dash-games',
    '/category/avoid': '/tag/avoid-games',
    '/category/visual-novel': '/tag/visual-novel-games',
    '/category/unity3d': '/tag/unity3d-games',
    '/category/vehicles': '/tag/vehicles-games',
    '/category/roblox': '/tag/roblox-games',
    '/category/memory': '/tag/memory-games',
    '/category/characters': '/tag/characters-games',
    '/category/medieval': '/tag/medieval-games',
    '/category/ambulance': '/tag/ambulance-games',
    '/category/mom': '/tag/mom-games',
    '/category/pet': '/tag/pet-games',
    '/category/blocky': '/tag/blocky-games',
    '/category/surfers': '/tag/surfers-games',
    '/category/planet': '/tag/planet-games',
    '/category/professional': '/tag/professional-games',
    '/category/life-simulation': '/tag/life-simulation-games',
    '/category/stars': '/tag/stars-games',
    '/category/colorful': '/tag/colorful-games',
    '/category/trial': '/tag/trial-games',
    '/category/tournament': '/tag/tournament-games',
    '/category/snowboarding': '/tag/snowboarding-games',
    '/category/brick': '/tag/brick-games',
    '/category/hypercasual': '/tag/hypercasual-games',
    '/category/crash': '/tag/crash-games',
    '/category/stealth': '/tag/stealth-games',
    '/category/hopy': '/tag/hopy-games',
    '/category/smash': '/tag/smash-games',
    '/category/beauty-salon': '/tag/beauty-salon-games',
    '/category/mentolatux': '/tag/mentolatux-games',
    '/category/shooter': '/tag/shooter-games',
    '/category/endless': '/tag/endless-games',
    '/category/mafia': '/tag/mafia-games',
    '/category/wedding': '/tag/wedding-games',
    '/category/detective': '/tag/detective-games',
    '/category/slide': '/tag/slide-games',
    '/category/jelly': '/tag/jelly-games',
    '/category/trial-bike-games': '/tag/trial-bike-games',
    '/category/creativity': '/tag/creativity-games',
    '/category/obstacles': '/tag/obstacles-games',
    '/category/flip': '/tag/flip-games',
    '/category/fairy-tale': '/tag/fairy-tale-games',
    '/category/vex': '/tag/vex-games',
    '/category/fairies': '/tag/fairies-games',
    '/category/painting': '/tag/painting-games',
    '/category/sofia': '/tag/sofia-games',
    '/category/highscore': '/tag/highscore-games',
    '/category/yoga': '/tag/yoga-games',
    '/category/neon': '/tag/neon-games',
    '/category/lines': '/tag/lines-games',
    '/category/darts': '/tag/darts-games',
    '/category/backflip': '/tag/backflip-games',
    '/category/challenging': '/tag/challenging-games',
    '/category/rts': '/tag/rts-games',
    '/category/connect': '/tag/connect-games',
    '/category/chair': '/tag/chair-games',
    '/category/sorting': '/tag/sorting-games',
    '/category/cute': '/tag/cute-games',
    '/category/guns': '/tag/guns-games',
    '/category/pyramid-solitaire': '/tag/pyramid-solitaire-games',
    '/category/pyramid-solitaire-games': '/tag/pyramid-solitaire-games',
    '/category/trollface': '/tag/trollface-games',
    '/category/goal': '/tag/goal-games',
    '/category/brain-out': '/tag/brain-out-games',
    '/category/skiing': '/tag/skiing-games',
    '/category/skateboard': '/tag/skateboard-games',
    '/category/room': '/tag/room-games',
    '/category/jumping': '/tag/jumping-games',
    '/category/crossword-puzzles': '/tag/crossword-puzzles-games',
    '/category/sliding': '/tag/sliding-games',
    '/category/heroes': '/tag/heroes-games',
    '/category/art': '/tag/art-games',
    '/category/breaking': '/tag/breaking-games',
    '/category/high-score': '/tag/high-score-games',
    '/category/tnt': '/tag/tnt-games',
    '/category/lol': '/tag/lol-games',
    '/category/rocket': '/tag/rocket-games',
    '/category/fly': '/tag/fly-games',
    '/category/controller': '/tag/controller-games',
    '/category/volleyball': '/tag/volleyball-games',
    '/category/speed': '/tag/speed-games',
    '/category/bricks': '/tag/bricks-games',
    '/category/arena': '/tag/arena-games',
    '/category/learning': '/tag/learning-games',
    '/category/roller-coaster': '/tag/roller-coaster-games',
    '/category/disney': '/tag/disney-games',
    '/category/spot-the-difference': '/tag/spot-the-difference-games',
    '/category/one-button': '/tag/one-button-games',
    '/category/one-button-games': '/tag/one-button-games',
    '/category/car-tuning': '/tag/car-tuning-games',
    '/category/seek-and-find': '/tag/seek-and-find-games',
    '/category/swing': '/tag/swing-games',
    '/category/webgl': '/tag/webgl-games',
    '/category/fish-aquarium': '/tag/fish-aquarium-games',
    '/category/mind': '/tag/mind-games',
    '/category/chicken': '/tag/chicken-games',
    '/category/text': '/tag/text-games',
    '/category/test': '/tag/test-games',
    '/category/motocross': '/tag/motocross-games',
    '/category/car-crash': '/tag/car-crash-games',
    '/category/nails': '/tag/nails-games',
    '/category/shop': '/tag/shop-games',
    '/category/gamerina-games': '/tag/gamerina-games',
    '/category/witch': '/tag/witch-games',
    '/category/avie': '/tag/avie-games',
    '/category/reward': '/tag/reward-games',
    '/category/drift': '/tag/drift-games',
    '/category/drift-games': '/tag/drift-games',
    '/category/defense': '/tag/defense-games',
    '/category/cut': '/tag/cut-games',
    '/category/audio': '/tag/audio-games',
    '/category/hide-and-seek': '/tag/hide-and-seek-games',
    '/category/doll': '/tag/doll-games',
    '/category/visual': '/tag/visual-games',
    '/category/combat': '/tag/combat-games',
    '/category/sword': '/tag/sword-games',
    '/category/craft': '/tag/craft-games',
    '/category/rescue': '/tag/rescue-games',
    '/category/turn-based': '/tag/turn-based-games',
    '/category/robbery': '/tag/robbery-games',
    '/category/amazing': '/tag/amazing-games',
    '/category/luck': '/tag/luck-games',
    '/category/luck-games': '/tag/luck-games',
    '/category/hidden-objects': '/tag/hidden-objects-games',
    '/category/color-matching': '/tag/color-matching-games',
    '/category/digging': '/tag/digging-games',
    '/category/touchscreen': '/tag/touchscreen-games',
    '/category/drag-racing': '/tag/drag-racing-games',
    '/category/drag-racing-games': '/tag/drag-racing-games',
    '/category/logical': '/tag/logical-games',
    '/category/surprise': '/tag/surprise-games',
    '/category/world': '/tag/world-games',
    '/category/road': '/tag/road-games',
    '/category/hip-hop': '/tag/hip-hop-games',
    '/category/collecting': '/tag/collecting-games',
    '/category/challenge': '/tag/challenge-games',
    '/category/trap': '/tag/trap-games',
    '/category/unicorns': '/tag/unicorns-games',
    '/category/cult': '/tag/cult-games',
    '/category/cartoon': '/tag/cartoon-games',
    '/category/super': '/tag/super-games',
    '/category/agility': '/tag/agility-games',
    '/category/gravity': '/tag/gravity-games',
    '/category/arrows': '/tag/arrows-games',
    '/category/true-or-false': '/tag/true-or-false-games',
    '/category/pomni': '/tag/pomni-games',
    '/category/nickelodeon': '/tag/nickelodeon-games',
    '/category/numbers': '/tag/numbers-games',
    '/category/desktop': '/tag/desktop-games',
    '/category/gangster': '/tag/gangster-games',
    '/category/rolling': '/tag/rolling-games',
    '/category/isometric': '/tag/isometric-games',
    '/category/person': '/tag/person-games',
    '/category/panda': '/tag/panda-games',
    '/category/kitty': '/tag/kitty-games',
    '/category/poop': '/tag/poop-games',
    '/category/1-player': '/tag/1-player-games',
    '/category/koala': '/tag/koala-games',
    '/category/box': '/tag/box-games',
    '/category/swipe': '/tag/swipe-games',
    '/category/circus': '/tag/circus-games',
    '/category/timing': '/tag/timing-games',
    '/category/kissing': '/tag/kissing-games',
    '/category/ghosts': '/tag/ghosts-games',
    '/category/helicopter': '/tag/helicopter-games',
    '/category/search': '/tag/search-games',
    '/category/family': '/tag/family-games',
    '/category/dance': '/tag/dance-games',
    '/category/egg': '/tag/egg-games',
    '/category/bloody': '/tag/bloody-games',
    '/category/surfing': '/tag/surfing-games',
    '/category/balance': '/tag/balance-games',
    '/category/tiles': '/tag/tiles-games',
    '/category/baby': '/tag/baby-games',
    '/category/builder': '/tag/builder-games',
    '/category/grow': '/tag/grow-games',
    '/category/indie': '/tag/indie-games',
    '/category/controller-compatible-games': '/tag/controller-compatible-games',
    '/category/mountain': '/tag/mountain-games',
    '/category/knights': '/tag/knights-games',
    '/category/shark': '/tag/shark-games',
    '/category/demolition-cars': '/tag/demolition-cars-games',
    '/category/celebrity': '/tag/celebrity-games',
    '/category/interactive-fiction': '/tag/interactive-fiction-games',
    '/category/traffic': '/tag/traffic-games',
    '/category/aircraft': '/tag/aircraft-games',
    '/category/sci-fi': '/tag/sci-fi-games',
    '/category/dentistry': '/tag/dentistry-games',
    '/category/vampires': '/tag/vampires-games',
    '/category/pet-grooming': '/tag/pet-grooming-games',
    '/category/movie': '/tag/movie-games',
    '/category/silver': '/tag/silver-games',
    '/category/robots': '/tag/robots-games',
    '/category/seduction': '/tag/seduction-games',
    '/category/frog': '/tag/frog-games',
    '/category/collection': '/tag/collection-games',
    '/category/sandbox': '/tag/sandbox-games',
    '/category/level': '/tag/level-games',
    '/category/eating': '/tag/eating-games',
    '/category/hearts': '/tag/hearts-games',
    '/category/capture': '/tag/capture-games',
    '/category/incremental': '/tag/incremental-games',
    '/category/dogs': '/tag/dogs-games',
    '/category/science': '/tag/science-games',
    '/category/rally': '/tag/rally-games',
    '/category/roguelike': '/tag/roguelike-games',
    '/category/building': '/tag/building-games',
    '/category/geometry': '/tag/geometry-games',
    '/category/games': '/',
    '/category/diamonds': '/tag/diamonds-games',
    '/category/aviation': '/tag/aviation-games',
    '/category/tactical': '/tag/tactical-games',
    '/category/bow': '/tag/bow-games',
    '/category/teams': '/tag/teams-games',
    '/category/bike-racing': '/tag/bike-racing-games',
    '/category/bike-racing-games': '/tag/bike-racing-games',
    '/category/chekers': '/tag/chekers-games',
    '/category/jump-scare': '/tag/jump-scare-games',
    '/category/kart': '/tag/kart-games',
    '/category/third-person-shooter-games': '/tag/third-person-shooter-games',
    '/category/cash': '/tag/cash-games',
    '/category/cash-games': '/tag/cash-games',
    '/category/horde-survival': '/tag/horde-survival-games',
    '/category/resource-management': '/tag/resource-management-games',
    '/category/mice': '/tag/mice-games',
    '/category/snow': '/tag/snow-games',
    '/category/mmo': '/tag/mmo-games',
    '/category/high-quality': '/tag/high-quality-games',
    '/category/slicing': '/tag/slicing-games',
    '/category/domino': '/tag/domino-games',
    '/category/weird': '/tag/weird-games',
    '/category/dungeon': '/tag/dungeon-games',
    '/category/slitherio': '/tag/slitherio-games',
    '/category/rival': '/tag/rival-games',
    '/category/russian': '/tag/russian-games',
    '/category/cartoon-network': '/tag/cartoon-network-games',
    '/category/pegasus': '/tag/pegasus-games',
    '/category/dunking': '/tag/dunking-games',
    '/category/king': '/tag/king-games',
    '/category/simple': '/tag/simple-games',
    '/category/psychology': '/tag/psychology-games',
    '/category/cartoons': '/tag/cartoons-games',
    '/category/bird': '/tag/bird-games',
    '/category/mermaid': '/tag/mermaid-games',
    '/category/sneak': '/tag/sneak-games',
    '/category/ping-pong': '/tag/ping-pong-games',
    '/category/killing': '/tag/killing-games',
    '/category/runner': '/tag/runner-games',
    '/category/stacking': '/tag/stacking-games',
    '/category/pirates-games': '/tag/pirates-games',
    '/category/billiards': '/tag/billiards-games',
    '/category/karting': '/tag/karting-games',
    '/category/children': '/tag/children-games',
    '/category/mining': '/tag/mining-games',
    '/category/open-world': '/tag/open-world-games',
    '/category/gold': '/tag/gold-games',
    '/category/historical': '/tag/historical-games',
    '/category/wheel': '/tag/wheel-games',
    '/category/pixel': '/tag/pixel-games',
    '/category/stairs': '/tag/stairs-games',
    '/category/piano': '/tag/piano-games',
    '/category/piano-games': '/tag/piano-games',
    '/category/fire': '/tag/fire-games',
    '/category/islands': '/tag/islands-games',
    '/category/throwing': '/tag/throwing-games',
    '/category/soldier': '/tag/soldier-games',
    '/category/horses': '/tag/horses-games',
    '/category/borwser': '/tag/borwser-games',
    '/category/jungle': '/tag/jungle-games',
    '/category/pinball': '/tag/pinball-games',
    '/category/santa-claus': '/tag/santa-claus-games',
    '/category/virtual': '/tag/virtual-games',
    '/category/slacking': '/tag/slacking-games',
    '/category/balloon': '/tag/balloon-games',
    '/category/rhythm': '/tag/rhythm-games',
    '/category/whack': '/tag/whack-games',
    '/category/buggy': '/tag/buggy-games',
    //categories to new redirects
    '/category/3-player-games': '/tag/3-player-games',
    '/category/2-player': '/category/two-player',
    '/category/duo': '/category/two-player',
    '/category/spiderman': '/series/spiderman-games',
    '/category/mountain-games': '/tag/mountain-games',
    '/category/crazy': '/category/crazy-games',
    '/category/silver-games': '/tag/silver-games',
    '/category/3d-games': '/category/3d',
    '/category/hello-kitty': '/series/hello-kitty-games',
    '/category/roblox-games': '/tag/roblox-games',
    '/category/8-ball-pool': '/series/8-ball-pool-games',
    '/category/helicopter-games': '/tag/helicopter-games',
    '/category/boxing-games': '/category/boxing',
    '/category/controller-games': '/tag/controller-games',
    '/category/peppa-pig': '/series/peppa-pig-games',
    '/category/granny': '/series/granny-games',
    '/category/miraculous-ladybug': '/series/miraculous-ladybug-games',
    '/category/fighter-jet-games': '/tag/fighter-jet-games',
    '/category/paw-patrol': '/series/paw-patrol-games',
    '/category/beauty-salon-games': '/tag/beauty-salon-games',
    '/category/hip-hop-games': '/tag/hip-hop-games',
    '/category/pregnancy-games': '/tag/pregnancy-games',
    '/category/scratch-games': '/tag/scratch-games',
    '/category/digging-games': '/tag/digging-games',
    '/category/hello-neighbor': '/series/hello-neighbor-games',
    '/category/monster-high': '/series/monster-high-games',
    '/category/post-apocalypse': '/category/zombie',
    '/category/decision': '/tag/decision-games',
    '/category/transformers': '/series/transformers-games',
    '/category/merge-games': '/category/merge',
    '/category/fast-and-the-furious': '/series/fast-and-the-furious-games',
    '/category/talking-angela': '/series/talking-angela-games',
    '/category/tom-and-jerry': '/series/tom-and-jerry-games',
    '/category/modification': '/',
    '/category/lazy-town': '/',
    '/category/1234567890': '/',
    '/category/charlotte': '/',
    '/category/0': '/',
    '/category/cars': '/category/car',
    '/category/for_babies': '/category/kids',
    '/category/for_boys': '/category/boys',
    '/category/for_girls': '/category/girls',
    '/category/for_two_persons': '/category/two-player',
    '/category/games_io': '/category/io',
    '/category/novels': '/category/story',
    '/category/puzzles': '/category/jigsaw-puzzles',
    //series to new redirects
    '/series/games-slitherio': '/category/io',
    // merging same tags
    '/tag/turnbased-games': '/tag/turn-based-games',
    '/category/turnbased-games': '/tag/turn-based-games',
    '/tag/valentine-games': '/tag/valentine-day-games',
    '/tag/valentines-games': '/tag/valentine-day-games',
    '/category/valentine': '/tag/valentine-day-games',
    '/category/valentine-day': '/tag/valentine-day-games',
    '/tag/valentine': '/tag/valentine-day-games',
    '/tag/valentines': '/tag/valentine-day-games',
    '/category/valentines': '/tag/valentine-day-games',
    '/series/assasin-games': '/series/assassin-games',
}
